import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Platform,
  ScrollView,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import DatePicker from "app/components/DatePicker";
import Autocomplete from "app/components/Autocomplete";

import store from "app/redux/store";

import Icon from "app/components/Icon";
import QuickActions from "app/components/QuickActions";
import ProgressRing from "app/components/ProgressRing";
// import { BlurView } from 'expo-blur';
import {
  AntDesign,
  Ionicons,
  FontAwesome,
  FontAwesome5,
  Feather,
  Entypo,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

export default class ValueInspector extends React.Component {
  static propTypes = {
    parent: PropTypes.object, //.isRequired,
    value: PropTypes.object.isRequired,
    // item: PropTypes.object.isRequired,
    // onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    // let { value, composer, parent, } = props
    // let itemIsValue = !composer && !!value?.id && typeof value.id !== 'string'
    // let timestamp = value?.timestamp || props.date || new Date()
    // if(composer) timestamp = new Date()

    // let progressIndex = null
    // let rawText = ''
    // let text = ''

    // if(itemIsValue){
    //   text = value?.text
    //   rawText = text
    // }
    // else {
    //   text = value?.note || ''
    //   if(text[1] == ':') text = text.substr(2)
    //   rawText = text
    // }

    // console.log(this.props.value)

    super(props);
    this.state = {
      // rawText,
      // itemIsValue,
      // text,
      // timestamp,
      // isDirty: props.composer,
      loading: false,
      ...this.initialState(),
    };
  }

  initialState = () => {
    let { value, composer, parent, date } = this.props;
    let itemIsValue = !composer && !!value?.id && typeof value.id !== "string";
    let timestamp = value?.timestamp || date || new Date();
    console.log(timestamp, value?.timestamp);
    if (itemIsValue)
      timestamp = value.completed
        ? valueHelpers.getCompletedAt(value)
        : value.created_at;
    if (composer) timestamp = date || new Date();

    let rawText = "";
    let text = "";
    let title = "";

    if (itemIsValue) {
      title = value?.title;
      text = value?.text;
      rawText = text;
    } else {
      text = value?.note || this.props.text || "";
      if (text[1] == ":") text = text.substr(2);
      rawText = text;
    }

    return {
      title,
      text,
      rawText,
      composer,
      itemIsValue,
      timestamp,
      isDirty: composer,
      incompleteChild: itemIsValue ? !value.complete : false,
      cycle: itemIsValue ? value.cycle : 1,
      frequency: itemIsValue ? value.frequency : null,
      snoozeUntil: itemIsValue ? value.snooze_until : null,
      isNote: itemIsValue ? value.is_note : null,
      selectingSnooze: false,
      selectingFrequency: false,
      selectingCycle: false,
      editingNote: false,
      // note: value.notes?.find((n) => n.startsWith("7:"))?.split(":")[1] || "",
      note: "",
      hidden: itemIsValue ? valueHelpers.isHidden(value) : false,
      child: null,
      addParent: false,
    };
  };

  render() {
    let { value, onClose, onUpdate, composer, fullBleed, style } = this.props;
    let {
      title,
      text,
      timestamp,
      progressIndex,
      itemIsValue,
      isDirty,
      incompleteChild,
      cycle,
      selectingCycle,
      frequency,
      selectingFrequency,
      snoozeUntil,
      selectingSnooze,
      loading,
      child,
      addParent,
      editingNote,
      note,
      isNote,
    } = this.state;

    let color = valueHelpers.getColor(value);
    let familyColor = valueHelpers.getColor(value, "familyColors");
    let ringColor = colorHelpers.averageColor([color, familyColor]);

    let childrenCount = itemIsValue
      ? valueHelpers.getChildren({ value }).length
      : null;

    return (
      <TouchableWithoutFeedback onPress={() => null}>
        <View
          style={[styles.wrapper, fullBleed && styles.fullBleedWrapper, style]}
        >
          {this.renderColorBg(value, color)}
          {this.renderIconBg(value, color)}

          <View style={[styles.container]}>
            <View style={[styles.row, { zIndex: 3 }]}>
              <DatePicker
                disabled
                selected={new Date(timestamp)}
                value={new Date(timestamp)}
                onChange={(timestamp) =>
                  this.setState({ timestamp, isDirty: true })
                }
              />
              <Feather name="x" style={styles.icon} onPress={onClose} />
            </View>

            {editingNote ? (
              <TextInput
                style={[styles.input, { color: valueHelpers.fontColor(value) }]}
                value={note}
                onChangeText={(note) => {
                  this.setState({ note, isDirty: true });
                }}
                placeholder={"notes..."}
                placeholderTextColor={colors.trim}
                multiline
                disabled={valueHelpers.isReference(value)}
              />
            ) : (
              <View style={{ flex: 1 }}>
                <TextInput
                  bold
                  style={[
                    styles.input,
                    { color: valueHelpers.fontColor(value) },
                  ]}
                  wrapperStyle={{
                    flexGrow: 0,
                    minHeight: sizes.default,
                    marginBottom: sizes.small,
                  }}
                  value={title}
                  onChangeText={(title) => {
                    this.setState({ title, isDirty: true });
                    if (!title?.length && !text?.length) {
                      this.setState({ ...this.initialState() });
                    }
                  }}
                  placeholder={"title.."}
                  placeholderTextColor={colors.trim}
                  // multiline
                  disabled={valueHelpers.isReference(value)}
                  autoFocus
                  onEnter={() => {
                    this.handleSubmit();
                  }}
                />
                <View style={{ flex: 1 }}>
                  <TextInput
                    style={[
                      // styles.input,
                      {
                        color: valueHelpers.fontColor(value),
                      },
                    ]}
                    value={text}
                    onChangeText={(text) => {
                      this.setState({ text, isDirty: true });
                      if (!title?.length && !text?.length) {
                        this.setState({ ...this.initialState() });
                      }
                    }}
                    placeholder={composer ? "add a note..." : "note.."}
                    placeholderTextColor={colors.trim}
                    multiline
                    // autoHeight
                    disabled={valueHelpers.isReference(value)}
                  />
                </View>
              </View>
            )}

            {composer && !child && (
              <Autocomplete
                suggestionsOnly
                query={text}
                // data={textHelpers.suggestions(
                //   text,
                //   valueHelpers.filterToCurrentRevisions(store.getState().values)
                //   // valueHelpers.filterToActive({
                //   //   values: store.getState().values,
                //   // })
                // )}
                simpleListView
                onSelectItem={this.selectChild}
                // renderItem={({ item, i }) => (
                //   <TouchableOpacity
                //     key={i}
                //     onPress={() => this.selectChild(item)}
                //   >
                //     <Text>{item.text}</Text>
                //   </TouchableOpacity>
                // )}
              />
            )}

            {selectingFrequency && (
              <View style={[styles.row]}>
                <Text style={{ color: valueHelpers.fontColor(value) }}>
                  Frequency:{" "}
                </Text>
                <View style={[styles.iconRow]}>
                  <Feather
                    name={"chevron-down"}
                    color={valueHelpers.fontColor(value)}
                    size={sizes.itemHeight}
                    onPress={() => {
                      if (!frequency || frequency == 1)
                        this.setState({ frequency: null, isDirty: true });
                      else
                        this.setState({
                          frequency: frequency - 1,
                          isDirty: true,
                        });
                    }}
                  />
                  <TextInput
                    value={frequency || ""}
                    style={[
                      styles.cycleInput,
                      { color: valueHelpers.fontColor(value) },
                    ]}
                    onChangeText={(frequency) =>
                      this.setState({ frequency, isDirty: true })
                    }
                    placeholder={"frequency"}
                  />
                  <Feather
                    name={"chevron-up"}
                    color={valueHelpers.fontColor(value)}
                    size={sizes.itemHeight}
                    style={{ marginRight: sizes.base }}
                    onPress={() => {
                      if (!frequency)
                        this.setState({ frequency: 1, isDirty: true });
                      else
                        this.setState({
                          frequency: frequency + 1,
                          isDirty: true,
                        });
                    }}
                  />
                </View>
              </View>
            )}

            {selectingCycle && (
              <View style={styles.row}>
                <Text style={{ color: valueHelpers.fontColor(value) }}>
                  Quota:{" "}
                </Text>
                <View style={styles.iconRow}>
                  {itemIsValue && childrenCount != cycle && (
                    <TouchableOpacity
                      onPress={() => {
                        this.setState({
                          isDirty: true,
                          cycle: childrenCount || 1,
                        });
                      }}
                    >
                      {/*<FontAwesome5 name='spinner' color={valueHelpers.fontColor(value)} size={sizes.itemHeight} 
                      style={{transform: [{rotate: '135deg'}]}}
                    />*/}
                      <MaterialCommunityIcons
                        name="auto-fix"
                        color={valueHelpers.fontColor(value)}
                        size={sizes.large}
                      />
                      {/*<ProgressRing 
                      value={{cycle: childrenCount}} 
                      size={sizes.itemHeight*0.8} emptyColor={valueHelpers.fontColor(value)} selected 
                    />*/}
                    </TouchableOpacity>
                  )}
                  <Feather
                    name={"chevron-down"}
                    color={valueHelpers.fontColor(value)}
                    size={sizes.itemHeight}
                    onPress={() =>
                      this.setState({
                        cycle:
                          cycle == null ? 0 : cycle == 0 ? null : cycle - 1,
                        isDirty: true,
                      })
                    }
                  />
                  <TextInput
                    value={cycle}
                    placeholderTextColor={colorHelpers.hexToRgbaString(
                      valueHelpers.fontColor(value),
                      0.5
                    )}
                    style={[
                      styles.cycleInput,
                      { color: valueHelpers.fontColor(value) },
                    ]}
                    onChangeText={(cycle) => this.setState({ cycle })}
                    placeholder={"#"}
                  />
                  <Feather
                    name={"chevron-up"}
                    color={valueHelpers.fontColor(value)}
                    size={sizes.itemHeight}
                    style={{ marginRight: sizes.base }}
                    onPress={() => {
                      let newCycle = cycle == null ? ENV.CYCLE : cycle + 1;
                      this.setState({ cycle: newCycle, isDirty: true });
                    }}
                  />
                </View>
              </View>
            )}

            <View style={[styles.row, { marginBottom: 0 }]}>
              {composer || itemIsValue ? (
                <View style={[styles.iconRow]}>
                  {!isNote && (
                    <TouchableOpacity
                      onPress={() => {
                        if (incompleteChild) {
                          // if (itemIsValue) {
                          this.setState({
                            selectingCycle: !selectingCycle,
                            selectingFrequency: false,
                          });
                          // } else {
                          //   if (!incompleteChild) cycle = ENV.CYCLE;
                          //   this.setState({
                          //     incompleteChild: !incompleteChild,
                          //     cycle,
                          //   });
                          // }
                        } else {
                          this.setState({ incompleteChild: true, cycle: null });
                        }
                      }}
                    >
                      <View style={[styles.iconRow]}>
                        {incompleteChild ? (
                          <View style={styles.icon}>
                            <ProgressRing
                              value={{ cycle }}
                              size={
                                ENV.WEB
                                  ? sizes.itemHeight * 0.8
                                  : sizes.itemHeight * 1.2
                              }
                              emptyColor={valueHelpers.fontColor(value)}
                              selected
                            />
                            {(!!cycle || cycle === 0) && (
                              <Text
                                center
                                style={styles.cycleText}
                                pointerEvents="none"
                              >
                                {cycle}
                              </Text>
                            )}
                          </View>
                        ) : (
                          <MaterialIcons
                            name="check-circle"
                            style={[
                              styles.icon,
                              incompleteChild && {
                                borderWidth: 3,
                                color: "transparent",
                              },
                            ]}
                          />
                        )}
                        <Text style={styles.text}>
                          {incompleteChild ? "" : "Completed"}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  )}
                  {incompleteChild && (
                    <View style={[styles.iconRow]}>
                      {/*!itemIsValue && (
                        <View style={[styles.iconRow]}>
                          <Feather
                            name={"chevron-down"}
                            color={valueHelpers.fontColor(value)}
                            size={sizes.itemHeight}
                            onPress={() => {
                              if (cycle == ENV.CYCLE)
                                this.setState({ cycle: 1 });
                              else
                                this.setState({
                                  cycle: Math.max(0, cycle - 1),
                                });
                            }}
                          />
                          <TextInput
                            value={cycle}
                            style={[
                              styles.cycleInput,
                              { color: valueHelpers.fontColor(value) },
                            ]}
                            onChangeText={(cycle) => this.setState({ cycle })}
                            placeholder={"cycle"}
                          />
                          <Feather
                            name={"chevron-up"}
                            color={valueHelpers.fontColor(value)}
                            size={sizes.itemHeight}
                            style={{ marginRight: sizes.base }}
                            onPress={() => {
                              this.setState({ cycle: cycle + 1 });
                            }}
                          />
                        </View>
                      )*/}

                      {/*<View style={{ marginRight: sizes.base }}>
                        <Feather
                          name="refresh-ccw"
                          color={valueHelpers.fontColor(value)}
                          size={sizes.itemHeight}
                          onPress={() =>
                            this.setState({
                              selectingFrequency: !selectingFrequency,
                              selectingCycle: false,
                            })
                          }
                        />
                        {!!frequency && (
                          <Text style={styles.cycleText} pointerEvents="none">
                            {frequency}
                          </Text>
                        )}
                      </View>*/}

                      {/*<View style={{ marginRight: sizes.base }}>
                        {!!snoozeUntil ? (
                          <Ionicons
                            name="md-moon"
                            color={valueHelpers.fontColor(value)}
                            size={sizes.itemHeight}
                            onPress={() =>
                              this.setState({
                                snoozeUntil: null,
                                selectingSnooze: false,
                                isDirty: true,
                              })
                            }
                          />
                        ) : (
                          <FontAwesome
                            name="moon-o"
                            color={valueHelpers.fontColor(value)}
                            size={sizes.itemHeight}
                            style={{ opacity: 0.5 }}
                            onPress={() =>
                              this.setState({
                                snoozeUntil: new Date(),
                                selectingSnooze: true,
                                isDirty: true,
                              })
                            }
                          />
                        )}
                      </View>*/}

                      {/*<View style={{ marginRight: sizes.base }}>
                        <Ionicons
                          name="md-eye-off"
                          size={sizes.itemHeight * 0.8}
                          color={valueHelpers.fontColor(value)}
                          style={!this.state.hidden && { opacity: 0.5 }}
                          onPress={() =>
                            this.setState({
                              hidden: !this.state.hidden,
                              isDirty: true,
                            })
                          }
                        />
                      </View>*/}

                      <View style={{ marginRight: sizes.base }}>
                        <FontAwesome
                          name="file-text-o"
                          color={valueHelpers.fontColor(value)}
                          size={sizes.itemHeight * 0.8}
                          // style={!editingNote && { opacity: 0.5 }}
                          style={!isNote && { opacity: 0.5 }}
                          onPress={() =>
                            this.setState({
                              // editingNote: !editingNote,
                              isNote: !isNote,
                              isDirty: true,
                            })
                          }
                        />
                      </View>

                      {selectingSnooze && (
                        <DatePicker
                          autoFocus
                          inputStyle={[
                            { zIndex: 3 },
                            { position: "absolute", bottom: 50 },
                          ]}
                          // onBlur={() => this.setState({selectingSnooze: false})}
                          // onSelect={() => this.setState({selectingSnooze: false})}
                          shouldCloseOnSelect={false}
                          selected={snoozeUntil ? new Date(snoozeUntil) : null}
                          value={!!snoozeUntil ? new Date(snoozeUntil) : null}
                          onChange={(val) => {
                            console.log(val);
                            this.setState({ snoozeUntil: val });
                          }}
                          // showTimeSelect
                        />
                      )}
                    </View>
                  )}
                </View>
              ) : (
                <View style={styles.iconRow}>
                  {!itemIsValue ? (
                    loading ? (
                      <ActivityIndicator />
                    ) : (
                      <Feather
                        name="trash-2"
                        style={styles.icon}
                        onPress={this.handleDelete}
                      />
                    )
                  ) : (
                    <MaterialIcons
                      name={"check-circle"}
                      color={colors.foreground}
                      style={[
                        styles.icon,
                        !value.completed && { opacity: 0.3 },
                      ]}
                      onPress={this.handleComplete}
                    />
                  )}
                  {/*<FontAwesome name='unlink' style={styles.icon} onPress={() => alert('break relationship')} />*/}
                  {/*<MaterialIcons name='control-point-duplicate' style={[styles.icon, {opacity: 0.3}]} onPress={() => alert('duplicate')} />*/}
                </View>
              )}
              <View style={[styles.iconRow, { justifyContent: "flex-end" }]}>
                {/*itemIsValue && (
                <MaterialCommunityIcons name='timeline-text-outline' style={styles.icon} onPress={() => alert('history')} />
              )*/}
                {(!!child || (composer && incompleteChild)) && (
                  <Entypo
                    name="flow-tree"
                    onPress={() => this.setState({ addParent: !addParent })}
                    style={[
                      styles.icon,
                      addParent && { transform: [{ rotateZ: "180deg" }] },
                    ]}
                  />
                )}
                {/*<AntDesign
                  name={"zap"}
                  style={[styles.icon]}
                  onPress={() => this.setState({ showQuickActions: true })}
                />*/}
                {itemIsValue && (
                  <AntDesign
                    name={"edit"}
                    style={[
                      styles.icon,
                      // { opacity: 0.4 }
                    ]}
                    onPress={() =>
                      RootNavigation.push("Edit", { id: value.id })
                    }
                  />
                )}
                {!this.props.hideShowButton && itemIsValue && (
                  <Entypo
                    name="chevron-right"
                    style={[styles.icon]}
                    onPress={() =>
                      RootNavigation.push("Value", {
                        id: child?.id || value.id,
                      })
                    }
                  />
                )}
                {loading ? (
                  <ActivityIndicator />
                ) : !!child ? (
                  <Feather
                    name="plus"
                    style={styles.icon}
                    onPress={this.handleAddChild}
                  />
                ) : (
                  <Feather
                    name="check"
                    style={[styles.icon, !isDirty && { opacity: 0.3 }]}
                    onPress={() => isDirty && this.handleSubmit()}
                  />
                )}
              </View>
            </View>

            {this.state.showQuickActions && (
              <QuickActions
                value={value}
                onUpdate={(updatedVal, newPrefs) => {
                  this.setState({ showQuickActions: false });
                  !!onDeselect && onDeselect();
                  !!onHideQuickActions && onHideQuickActions();
                  !!onUpdate && onUpdate(updatedVal, newPrefs);
                }}
                onView={this.props.onViewValue}
                onClose={() => {
                  this.setState({ showQuickActions: false });
                  !!onDeselect && onDeselect();
                  !!onHideQuickActions && onHideQuickActions();
                }}
              />
            )}
          </View>
        </View>
      </TouchableWithoutFeedback>
    );
  }

  renderColorBg = (value, color) => {
    let size = 100;
    let darkenBy = colors.darkenBy;
    let darkenedColor = colorHelpers.modifyHex(color, darkenBy);
    if (typeof value?.id == "string" && value.id.includes("ftue")) {
      darkenedColor = "transparent";
    }
    return (
      <View
        style={{
          ...StyleSheet.absoluteFillObject,
          backgroundColor: darkenedColor,
          borderRadius: sizes.borderRadius,
        }}
      />
    );
  };

  renderIconBg = (value, valColor) => {
    let size = 100;
    // let icon = value?.icon;
    let icon = valueHelpers.getIcon(value);
    if (!!icon) {
      let { color, opacity } = valueHelpers.iconColor(value, valColor);
      let gutterSize = (size / 2) * 0.2 * screenRatio;
      let style = {
        ...StyleSheet.absoluteFillObject,
        top: gutterSize,
        right: gutterSize,
        bottom: gutterSize,
        left: gutterSize,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      };
      if (this.state.editingNote) {
        return (
          <View style={style}>
            <FontAwesome
              name="file-text-o"
              size={size * 0.7 * screenRatio}
              style={{ opacity, color }}
            />
          </View>
        );
      }
      return (
        <View style={style}>
          <Icon
            name={icon}
            // color={valueHelpers.color(value)}
            color={color}
            size={size * 0.7 * screenRatio}
            style={{ opacity }}
            hideOverflow
          />
        </View>
      );
    }
  };

  handleDelete = async () => {
    this.setState({ loading: true });
    let { value, parent, onClose } = this.props;
    let item = parent || value;
    let res = await valueActions.deleteProgress(item, value.timestamp);
    this.setState({ loading: false });
    if (!!res) onClose();
  };

  handleComplete = async () => {
    this.setState({ loading: true });
    let { value, onClose } = this.props;
    let { timestamp } = this.state;
    let res = await valueActions.complete(value, timestamp);
    this.setState({ loading: false });
    if (!!res) onClose();
  };

  selectChild = (child) => {
    this.setState({
      child,
      text: child.text,
      timestamp: valueHelpers.getTimestamp({ value: child }),
      snoozeUntil: child.snooze_until,
      cycle: child.cycle,
      frequency: child.frequency,
      incompleteChild: !child.completed,
      isDirty: true,
      itemIsValue: true,
    });
  };

  handleAddChild = async () => {
    let { parent, onClose } = this.props;
    let { child, addParent } = this.state;
    this.setState({ loading: true });
    if (addParent) {
      await valueActions.addChild(child, parent);
    } else {
      await valueActions.addParent(child, parent);
    }
    this.setState({ loading: false });
    onClose();
  };

  handleSubmit = async () => {
    let {
      parent,
      value,
      onUpdate,
      onClose,
      onProgress,
      onCreateChild,
      composer,
      createChapter,
    } = this.props;
    let {
      timestamp,
      title,
      text,
      itemIsValue,
      cycle,
      frequency,
      snoozeUntil,
      incompleteChild,
      addParent,
      hidden,
      note,
      isNote,
    } = this.state;

    let createdValue = null;

    this.setState({ loading: true });

    if (composer) {
      // create child value
      if (incompleteChild || !!text?.length) {
        if (!text?.length && !title?.length) {
          alert("Title or body is required");
          return;
        }
        let newValue = {
          text,
          created_at: timestamp,
          parent_ids: [parent.id],
          cycle,
          frequency,
        };
        // if (!!note?.length) {
        //   newValue.notes = [`7:${note}`];
        // }
        if (isNote !== null) {
          newValue.is_note = isNote;
        }
        if (addParent && incompleteChild) {
          // adding a parent rather than a child
          newValue.parent_ids = [];
          newValue.child_ids = [parent.id];
        }
        if (!!snoozeUntil) newValue.snooze_until = snoozeUntil;
        if (!incompleteChild) {
          newValue.completed_at = timestamp;
          newValue.progress_at = [timestamp];
          newValue.completed = true;
        }
        if (cycle == ENV.CYCLE) newValue.cycle = null;
        createdValue = await valueActions.create(newValue, null, createChapter);
      }
      // create progress
      else {
        await valueActions.progress(parent.id, timestamp);
      }
    } else {
      // update value
      if (itemIsValue) {
        let data = {
          text,
          title,
          snooze_until: snoozeUntil,
          cycle,
          frequency,
        };
        if (isNote !== null) {
          data.is_note = isNote;
        }
        // timestamp is either's created_at or completed_at
        if (!!value.completed) {
          data.completed_at = timestamp;
          if ([0, 1].includes(value.progress_at?.length)) {
            data.progress_at = [timestamp];
          }
        } else {
          data.created_at = timestamp;
        }
        // if (!!note?.length) {
        //   data.notes = [`7:${note}`];
        // }

        await valueActions.update(value.id, data);

        if (hidden && !valueHelpers.isHidden(value)) {
          await prefActions.hideValue(value.id);
        } else if (!hidden && valueHelpers.isHidden(value)) {
          await prefActions.unhideValue(value.id);
        }
      } else {
        // update parent progress
        let progressAt = textHelpers.oldestFirst(parent.progress_at);
        let progressIndex = progressAt?.indexOf(value.timestamp);
        progressAt[progressIndex] = timestamp;

        let data = {
          progress_at: progressAt,
        };

        // notes
        // if (text?.length) {
        //   let newNote = `${progressIndex}:${text}`;
        //   let notes = textHelpers.oldestFirst(parent.notes);
        //   if (!notes.find((n) => n.startsWith(progressIndex))) {
        //     notes.push(newNote);
        //   } else {
        //     notes = notes.map((n) =>
        //       n.startsWith(progressIndex) ? newNote : n
        //     );
        //   }
        //   notes = textHelpers.oldestFirst(notes);
        //   data.notes = notes;
        // }
        await valueActions.update(parent.id, data);
      }
    }

    this.setState({ loading: false });
    onClose(createdValue);
  };
}

const styles = StyleSheet.create({
  wrapper: {
    // borderRadius: 10,
    // overflow: 'hidden',
    width: 300,
    height: 300,
    margin: sizes.base,
  },
  fullBleedWrapper: {
    // width: '100%',
    width: "auto",
    height: 200,
    alignSelf: "stretch",
    // flex: 1,
  },
  container: {
    flex: 1,
    padding: sizes.base,
    alignItems: "stretch",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: sizes.base,
  },
  text: {
    color: colors.lightForeground,
  },
  quickActionsWrapper: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "center",
    backgroundColor: colors.trim,
    borderRadius: 5,
    padding: 5,
    paddingRight: 0,
    position: "absolute",
    // bottom: '100%',
    left: 0,
    top: 0,
    right: 0,
    // minWidth: 220,
    // borderWidth: 1, borderColor: 'red',
  },
  iconRow: {
    flex: -1,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  icon: {
    marginRight: sizes.base,
    fontSize: sizes.itemHeight,
    width: sizes.itemHeight,
    height: sizes.itemHeight,
    borderRadius: sizes.itemHeight / 2,
    borderColor: colors.lightForeground,
    color: colors.lightForeground,
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    ...styleSheet.input,
    backgroundColor: "transparent",
    flex: 1,
  },
  cycleInput: {
    ...styleSheet.input,
    // backgroundColor: 'transparent',
    padding: sizes.small,
    // marginLeft: sizes.base,
    marginBottom: 0,
    alignSelf: "center",
    width: sizes.large * 1.5,
    textAlign: "center",
  },
  cycleText: {
    color: colors.lightForeground,
    fontSize: sizes.base,
    position: "absolute",
    top: "54%",
    left: "53%",
    transform: ENV.WEB
      ? [{ translateX: "-50%" }, { translateY: "-50%" }]
      : [{ translateX: -sizes.small - 1 }, { translateY: -sizes.small - 1 }],
  },
});
